// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--34MKe","title":"a10a3f92e9--title--G3Kyg","text":"a10a3f92e9--text--6huig"};